import axios from "axios"

export default {
    state : {
        persons : []
    },
    getters : {
        persons(state) {
            return state.persons;
        }
    },
    mutations : {
        setPersons(state, persons) {
            state.persons = persons;
        }
    },
    actions : {
       async getStudent({commit}) {
          let res =  await axios.get('/person/1');
          let persons = res.data.data;

          commit('setPersons', persons)
       } 
    }
}